var render, staticRenderFns
import script from "./CrtUser.vue?vue&type=script&lang=js&"
export * from "./CrtUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22565607')) {
      api.createRecord('22565607', component.options)
    } else {
      api.reload('22565607', component.options)
    }
    
  }
}
component.options.__file = "src/views/User/Perfil/CrtUser.vue"
export default component.exports